const Modal = {
  parts: ['overlay', 'dialog', 'header', 'closeButton', 'body', 'footer'],
  baseStyle: {
    overlay: {
      bg: 'overlay',
    },
    dialog: {
      borderRadius: 0,
      boxShadow: 'none',
      height: {
        base: '100%',
        sm: 'auto',
      },
      margin: {
        base: 0,
        sm: 'inherit',
      },
      maxHeight: {
        base: '100%',
        sm: 'inherit',
      },
      maxWidth: {
        base: '100%',
        sm: '480px',
        md: '640px',
      },
    },
    header: {
      borderBottom: '1px solid',
      borderBottomColor: 'gray.100',
      fontSize: '1em',
      px: 7,
      py: 7,
      textAlign: 'center',
    },
    closeButton: {
      right: 6,
      top: 6,
    },
    body: {
      px: {
        base: 9,
        sm: '64px',
      },
      py: {
        base: 8,
        sm: 10,
      },
      overflowY: 'auto',
      maxHeight: '60vh',
    },
    footer: {
      borderTop: '1px solid',
      borderTopColor: 'gray.100',
      px: 6,
      py: 4,
    },
  },
};

export default Modal;
